/**
 * clipboard.ts — Utility puro para copiar texto al portapapeles.
 *
 * QUÉ HACE:
 *   - Intenta `navigator.clipboard.writeText` (API moderna, requiere HTTPS o
 *     localhost y user gesture).
 *   - Si no está disponible o falla (navegador antiguo, contexto inseguro),
 *     usa el fallback clásico con `document.execCommand('copy')`.
 *
 * QUÉ EXPORTA:
 *   - copyTextToClipboard(text): Promise<boolean>
 *
 * QUÉ NO HACE:
 *   - No muestra UI/toast: el caller decide cómo notificar al usuario.
 *   - No conoce de React, modales ni stores.
 */

export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (typeof navigator === "undefined" || typeof document === "undefined") {
    return false;
  }
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // cae al fallback
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.left = "-1000px";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
